import { useCallback, useMemo } from 'react';

import includes from 'lodash/includes';

import {
  DataGridPremium,
  GridColDef,
  GridInitialStatePremium,
  GridRowIdGetter,
  Typography,
} from '@sbv-clients/ui-shared';
import {
  formatDateTimeString,
  formatLocalTimeString,
} from '@sbv-clients/util-misc';

import { DataType, ModalType, ModalTypeConfig } from './types';

interface TableProps {
  type: ModalType;
  data: DataType[];
}

const initialState: GridInitialStatePremium = {
  pagination: { paginationModel: { pageSize: 10 } },
};
const UnScheduledTable = ({ type, data }: TableProps) => {
  const columns = useMemo(() => {
    const columns = [
      {
        field: 'employeeName',
        headerName: 'Employee Name',
        flex: 1,
        sortable: false,
      },
      {
        field: 'position',
        headerName: 'Position Name',
        flex: 1,
        sortable: false,
      },
      {
        field: 'positionName',
        headerName: 'Position Name',
        flex: 1,
        sortable: false,
      },
      {
        field: 'startTime',
        headerName: 'Start Time',
        flex: 1,
        sortable: false,
      },
      {
        field: 'endTime',
        headerName: 'End Time',
        flex: 1,
        sortable: false,
      },
      {
        field: 'startDateTime',
        headerName: 'Schedule Start Time',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.startDateTime) {
            return formatLocalTimeString(params.row.startDateTime, 'hh:mm a');
          }
          return '';
        },
      },
      {
        field: 'endDateTime',
        headerName: 'Schedule End Time',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.endDateTime) {
            return formatLocalTimeString(params.row.endDateTime, 'hh:mm a');
          }
          return '';
        },
      },
      {
        field: 'punchDate',
        headerName: 'Punch Date',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row) {
            return formatDateTimeString(params.row.punchTime);
          }
          return '';
        },
      },
      {
        field: 'actualInPunchDate',
        headerName: 'Punch Date',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.actualInPunchDateTime) {
            return formatDateTimeString(params.row.actualInPunchDateTime);
          }
          return '';
        },
      },
      {
        field: 'actualOutPunchDate',
        headerName: 'Punch Date',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.actualOutPunchDateTime) {
            return formatDateTimeString(params.row.actualOutPunchDateTime);
          }
          return '';
        },
      },
      {
        field: 'punchTime',
        headerName: 'Punch Time',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.punchTime) {
            return formatDateTimeString(params.row.punchTime, 'hh:mm a');
          }
          return '';
        },
      },
      {
        field: 'lateMinutes',
        headerName: 'Late Minutes',
        flex: 1,
        sortable: false,
      },
      {
        field: 'actualInPunchDateTime',
        headerName: 'In Punch Time',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.actualInPunchDateTime) {
            return (
              <Typography>
                {formatDateTimeString(
                  params.row.actualInPunchDateTime,
                  'hh:mm a'
                )}
              </Typography>
            );
          }
          return '';
        },
      },
      {
        field: 'actualOutPunchDateTime',
        headerName: 'Out Punch Time',
        flex: 1,
        sortable: false,
        renderCell: (params) => {
          if (params.row.actualOutPunchDateTime) {
            return (
              <Typography>
                {formatDateTimeString(
                  params.row.actualOutPunchDateTime,
                  'hh:mm a'
                )}
              </Typography>
            );
          }
          return '';
        },
      },
      {
        field: 'overTimeMinutes',
        headerName: 'Overtime',
        flex: 1,
        sortable: false,
      },
    ] as GridColDef<DataType>[];

    const fields = ModalTypeConfig[type].fields;
    return columns.filter((item) => includes(fields, item.field));
  }, [type]);

  const getRowId: GridRowIdGetter<DataType> = useCallback(
    (row) =>
      [row.employeeId, row.position, row.startDateTime, row.endDateTime].join(
        '-'
      ) as string,
    []
  );

  return (
    <DataGridPremium
      rows={data}
      columns={columns}
      disableRowSelectionOnClick
      getRowId={getRowId}
      disableColumnMenu
      pagination
      initialState={initialState}
      pageSizeOptions={[5, 10, 25]}
    />
  );
};

export default UnScheduledTable;
